import type { QueryDocumentSnapshot, DocumentData } from 'firebase/firestore';
import type { BlogPost } from '@/dashboard/types/blog';

/**
 * Cache em memória (módulo, não localStorage) só pra esta sessão de navegação
 * — spec do blog, seção 5: "se o usuário abrir um artigo e retornar à lista,
 * não deve ser necessário consultar novamente". Limpa sozinho num reload
 * completo, o que é o comportamento pedido ("mesma sessão").
 */

const postsBySlug = new Map<string, BlogPost>();

interface ListingState {
  posts: BlogPost[];
  lastDoc: QueryDocumentSnapshot<DocumentData> | null;
  done: boolean;
}

let listing: ListingState | null = null;

export function getCachedPost(slug: string): BlogPost | undefined {
  return postsBySlug.get(slug);
}

export function setCachedPost(post: BlogPost): void {
  postsBySlug.set(post.slug, post);
}

export function getCachedListing(): ListingState | null {
  return listing;
}

export function setCachedListing(state: ListingState): void {
  listing = state;
  for (const post of state.posts) postsBySlug.set(post.slug, post);
}

export function clearBlogCache(): void {
  postsBySlug.clear();
  listing = null;
}
